import http from 'axios'
import urls from './adminSettings.urls'

export default {
  uploadFile: ({ state, rootState, commit }, file) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('name', file.name)

    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post(urls.upload, formData)
      .then(response => {
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  downloadFile: () => {
    const accessToken = window.sessionStorage.getItem('access_token')
    let origin = window.location.origin
    if (origin == null) {
      origin = window.location.protocol + '//' + window.location.hostname +
          (window.location.port ? ':' + window.location.port : '')
    }
    window.open(origin + urls.download + '?access_token=' + accessToken)
  },
  refreshClientCache: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.refreshClient)
      .then(response => {
        commit('checkFailed', { ret: response.data, type: 'Refreshing client cache' })
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  refreshFeatureCache: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.refreshFeature)
      .then(response => {
        commit('checkFailed', { ret: response.data, type: 'Refreshing feature cache' })
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  disconnectDatabase: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .get(urls.disconnectDatabase)
      .then(response => {
        commit('checkFailed', { ret: response.data, type: 'Disconnecting databases' })
        commit('global/setShowLoadingSpinner', false, { root: true })
      }).catch(() => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
      })
  },
  logout: ({ state, rootState, commit }) => {
    commit('global/setShowLoadingSpinner', true, { root: true })
    return http
      .post('/mrx-gateway/api/logout')
      .then(response => {
        commit('global/setShowLoadingSpinner', false, { root: true })
        return response.data
      }, error => {
        commit('global/setShowErrorMessage', true, { root: true })
        commit('global/setShowLoadingSpinner', false, { root: true })
        throw error
      })
  }
}
